import { type ReactNode } from 'react';

import { Box } from '@mui/material';

// The scrollable content region of every screen: the Box that sits between the
// app bar and the footer / tab bar. Named so every screen's body is identical.
// It IS a Box — flex:1 to fill the space, overflow:auto so only the body
// scrolls (the chrome stays put), with the standard screen gutter. Padding is
// overridable for the few screens that need a tighter gutter or footer space.
const Body = ({
  children,
  px = 3,
  pt = 3,
  pb = 3,
}: {
  children?: ReactNode;
  px?: number | string;
  pt?: number | string;
  pb?: number | string;
}) => (
  <Box sx={{ flex: 1, overflow: 'auto', px: px, pt: pt, pb: pb }}>
    {children}
  </Box>
);

export default Body;
